import styled from 'styled-components';
import { em } from 'modules/helpers/style';

export const FakeButton = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    text-decoration: none;
    background-color: transparent;
    padding: 0;
    text-decoration: underline;
    text-underline-offset: ${em(4)};
    color: ${({ theme }) => theme.ComponentsCtaInlineText};

    &:hover {
        color: ${({ theme }) => theme.ComponentsCtaInlineTextHover};
    }
`;
